var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tap-option" }, [
    _c("h3", { staticClass: "tp-op-title" }, [_vm._v(_vm._s(_vm.title))]),
    _vm._v(" "),
    _c("div", { staticClass: "tp-op-limit" }, [_vm._t("limit")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "tp-op-use" }, [
      _c(
        "button",
        { class: "button-" + _vm.type, on: { click: _vm.viewDetail } },
        [_vm._v("\n\t\t\t" + _vm._s(_vm.actions) + "\n\t\t")]
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "tp-op-benifit" }, [
      _c("li", [
        _c("i", { staticClass: "icon psprite psprite-icon_check" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT1")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", { staticClass: "icon psprite psprite-icon_check" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT2")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", { staticClass: "icon psprite psprite-icon_check" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT3")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", { staticClass: "icon psprite psprite-icon_check" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT4")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT5")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "upload-file-limit" },
        [
          _c("i", {
            staticClass: "icon psprite psprite-icon_check",
            class: { disable: _vm.type === "free" }
          }),
          _vm._v(" "),
          _c("UploadTip", {
            attrs: {
              text: _vm.getConstants("PRICING_NEW_COMMON_PROFIT6"),
              content: _vm.getConstants("PRICING_NEW_COMMON_PROFIT6_TIP")
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT7")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT8")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT9")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT10")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", {
          staticClass: "icon psprite psprite-icon_check",
          class: { disable: _vm.type === "free" }
        }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm.getConstants("PRICING_NEW_COMMON_PROFIT11")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }